// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"43":"ff73faa9","223":"91539fc7","425":"45f68e1a","524":"f90a430a","623":"f46184f2","788":"39d35571","993":"c5ae7412","994":"b38e77c1"}[chunkId] + ".js";
};